// Libs
// Contexts
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

// Constants
import { ROUTE_LOGIN } from '@/common/constants';
import { useAuth } from '@/common/contexts/AuthContext';

const Logout = () => {
  const { logout } = useAuth();
  const history = useHistory();

  useEffect(() => {
    logout();
    history.push(ROUTE_LOGIN);
  });

  return null;
};

export default Logout;
